import { render } from "./AllUsers.vue?vue&type=template&id=af61e4b8"
import script from "./AllUsers.vue?vue&type=script&lang=js"
export * from "./AllUsers.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__